
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueLocalStorage from 'vue-localstorage';
//import Amplify, * as AmplifyModules from 'aws-amplify';
//import { Auth } from 'aws-amplify';
import axios from 'axios'
import BootstrapVue from 'bootstrap-vue/dist/bootstrap-vue.esm';
import VueRouterUserRoles from "vue-router-user-roles";
import IdleJs from 'idle-js'
import VueSweetalert2 from 'vue-sweetalert2';
import vueTippy from 'vue-tippy';
import vuetify from './plugins/vuetify'
//import Chat from 'vue-beautiful-chat';
import moment from "moment";
import VueMomentJS from "vue-momentjs";
import ExportarExcel from '@/components/ExportarExcel/ExportarExcel.vue';
import UploadExcelComponent from '@/components/UploadExcel/index.vue';
import UploadExcelComponent2 from '@/components/UploadExcel/indexComponent2.vue';
import HighchartsVue from 'highcharts-vue';
import CKEditor from '@ckeditor/ckeditor5-vue';
import VueIziToast from 'vue-izitoast';
import vueScrollto from 'vue-scrollto';
import VueTheMask from 'vue-the-mask'
import plugin from '@serializedowen/vue-img-watermark'
import VueHtml2Canvas from 'vue-html2canvas';
import Clipboard from 'v-clipboard';
import VueLazyload from 'vue-lazyload';

import VueCryptojs from 'vue-cryptojs'



import 'izitoast/dist/css/iziToast.css';

import 'regenerator-runtime/runtime'
import './plugins/base'
import './plugins/chartist'
import './plugins/vee-validate'
//import './plugins/vue-world-map'
import './plugins/vue-table'
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';


import VueCtkDateTimePicker from 'vue-ctk-date-time-picker';
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css';



Vue.component('VueCtkDateTimePicker', VueCtkDateTimePicker);
Vue.use(VueCryptojs);
Vue.use(VueLazyload);
Vue.use(VueIziToast);
Vue.use(HighchartsVue)
Vue.use(VueSweetalert2);
Vue.use(VueRouterUserRoles, {router});
Vue.use(vueTippy);
//Vue.use(Chat);
Vue.use(BootstrapVue);
Vue.use(VueMomentJS, moment);
Vue.component('exportarExcel', ExportarExcel);
Vue.component('UploadExcelComponent', UploadExcelComponent);
Vue.component('UploadExcelComponent2', UploadExcelComponent2);

Vue.use(CKEditor);
Vue.use(vueScrollto);
Vue.use(VueTheMask);
Vue.use(VueHtml2Canvas);
Vue.use(plugin);
Vue.use(Clipboard);


Vue.config.productionTip = false

Vue.prototype.$sistema = '1';
Vue.prototype.$hostname =  'https://api.econnectpro.mx/';
Vue.prototype.$apiSA31 =  'https://apisoluciona.econnectpro.mx/';
Vue.prototype.$apiReportes =  'https://apireportes.econnectpro.mx/';
Vue.prototype.$apiVucem =  'https://apivucem.econnectpro.mx/';
Vue.prototype.$apiToken = 'undefined';
Vue.prototype.$uuid = require('uuid');

let getUser = Promise.resolve({ role: 'guest', id_cliente:'0' });
Vue.use(VueLocalStorage, {name: 'local_storage', bind: true});

var idle = null;
const urlConfiguracion = Vue.prototype.$hostname+"catalogos/configuracion/";

if(Vue.prototype.$local_storage.get('id_usuario') > 0){

     getUser = Promise.resolve({
       role: Vue.prototype.$local_storage.get('tipo_usuario'),
       id_cliente:Vue.prototype.$local_storage.get('id_cliente')
      });
}
Vue.prototype.$crypto = {
  encrypted: value => {
    if(value)
      return Vue.CryptoJS.AES.encrypt(value , "aAxtTljJVO%.cmt#.LMKs234.675q").toString();
    else
      return "";
  },
  decrypted: value => {
    if(value)
    return Vue.CryptoJS.AES.decrypt(value , "aAxtTljJVO%.cmt#.LMKs234.675q").toString(Vue.CryptoJS.enc.Utf8);
    else
    return "";
  },
  SHA256: value => {
    return Vue.CryptoJS.SHA256(value + "p0w3r", "aAxtTljJVO%.cmt#.LMKs234.675q").toString();;
  },
};
Vue.prototype.$rules = {
  validaDiasConsulta: function(fecha_de, fecha_a) {

    if(Vue.prototype.$local_storage.get('tipo_usuario') == "Super Usuario" || Vue.prototype.$local_storage.get('tipo_usuario') == "Grupo" ) {
      var dias = 1830;
    } else {
      var dias = Vue.prototype.$local_storage.get('dias_cliente');
    }

    if (fecha_de != "" && fecha_a != "") {
      var inicio = moment(fecha_de, "YYYY-MM-DD");
      var fin = moment(fecha_a, "YYYY-MM-DD");
      var diferencia = fin.diff(inicio, 'days')
      if (diferencia > dias)
        return `El rango máximo permitido es ${dias} días.`
    }
    return true;
  }
};

/*Amplify.configure({
  Auth: {
      region: 'us-east-1',

        identityPoolRegion: 'us-east-1',
        userPoolId: 'us-east-1_s1zhiuODD',
        userPoolWebClientId: '1ctthegf72m836hu0to3r6837m',
        mandatorySignIn: false,
    }
});*/

try {
  /*async function loginApi() {
    const user = await Auth.signIn('apiuser_econnect', 'Econnect.2019');
    if (user.challengeName === 'SMS_MFA' ||
        user.challengeName === 'SOFTWARE_TOKEN_MFA') {
        // You need to get the code from the UI inputs
        // and then trigger the following function with a button click
        const code = getCodeFromUserInput();
        // If MFA is enabled, sign-in should be confirmed with the confirmation code
        const loggedUser = await Auth.confirmSignIn(
            user,   // Return object from Auth.signIn()
            code,   // Confirmation code
            mfaType // MFA Type e.g. SMS, TOTP.
        );
    } else if (user.challengeName === 'NEW_PASSWORD_REQUIRED') {
        const { requiredAttributes } = user.challengeParam;
        const loggedUser =  await Auth.completeNewPassword(
            user,
            'Econnect.2019',
            {
              'nickname':'apiuser_econnect',
            }
        );
    } else if (user.challengeName === 'MFA_SETUP') {
        Auth.setupTOTP(user);
    } else {
        // The user directly signs in
        //console.log(user);
        if (typeof user.signInUserSession.idToken != 'undefined'){
            Vue.prototype.$apiToken = user.signInUserSession.idToken.jwtToken;
            cargarConfiguracion();
        }

    }
  }*/ //loginAPi

  //loginApi();
  cargarConfiguracion();

} catch (err) {
  if (err.code === 'UserNotConfirmedException') {
  } else if (err.code === 'PasswordResetRequiredException') {
  } else if (err.code === 'NotAuthorizedException') {
  } else if (err.code === 'UserNotFoundException') {
  } else {
      console.log(err);
  }
}

function cargarConfiguracion() {
  axios.post(urlConfiguracion+'get_configuracion_sistema/', {sistema:Vue.prototype.$sistema})
    .then((res) => {
        if(typeof res.data !== 'undefined') {
          Vue.prototype.$configuracionSistema = res.data;
          Vue.prototype.$hostname = res.data.api_url;

            //Son milisegundos, se multiplica por 60000 para convertirlo a minutos
            var tiempoInactividad = res.data.tiempo_inactividad_sesion * 60000;
            //Detecta cuando la app alcanza el tiempo de inactividad
            idle = new IdleJs({
              idle: tiempoInactividad,
              onIdle () {
                idle.start();
                vm.verificaSesion('inactividad');
              },
            });
            idle.start();
        }
    })
    .catch((err) => {
        console.log(err);
    });
}




axios.interceptors.request.use(function (config) {
  //Se agrega user_updated para el log del sistema
  if (Vue.prototype.$local_storage.get('id_usuario') > 0 && (typeof config.data != 'undefined') && config.url.indexOf('s3.amazonaws') === -1)
      config.data.user_updated = Vue.prototype.$local_storage.get('email');
      //se agrega referencia para filtrado
  if (Vue.prototype.$local_storage.get('referencia_usuario') != "" && (typeof config.data != 'undefined') && config.data.referencia== undefined && config.url.indexOf('s3.amazonaws') === -1)
      config.data.referencia = Vue.prototype.$local_storage.get('referencia_usuario');

  if (config.method == 'delete' && config.url.indexOf('s3.amazonaws') === -1){
      var user = '?user_updated=';
      if ( config.url.indexOf('?') !== -1)
          user = '&user_updated='
      config.url += user + Vue.prototype.$local_storage.get('email');
  }

  // Se agrega el token para las apis
  if(Vue.prototype.$local_storage.get('token') != null && Vue.prototype.$local_storage.get('token') != '' && Vue.prototype.$local_storage.get('token') != undefined) {
    if ( config.url.indexOf('s3.amazonaws') === -1) //A las peticiones de S3 no se debe agregar el token
      config.headers.Authorization = "Token " + Vue.prototype.$local_storage.get('token');
  } else {
      config.headers.Authorization = null;
  }

  // Verifica la sesión antes de cada llamada de axios
  vm.verificaSesion(config.url);
  /*return Auth.currentSession()
    .then(session => {
      // User is logged in. Set auth header on all requests
      Vue.prototype.$apiToken = session.idToken.jwtToken;
      // config.headers.Authorization = session.idToken.jwtToken;
      return Promise.resolve(config);
    })
    .catch(() => {
      // No logged-in user: don't set auth header
      return Promise.resolve(config);
    })*/
  return config;
}, function (error) {
  return Promise.reject(error);
});

/*axios.interceptors.response.use(function (response) {
    return response;
}, function (error) {
  //Si la respuesta es Unauthorized, significa que no se ha logueado el usuario que utiliza la API de Aws y debe recargarse
  //la aplicación para que se vuelva a loguear.
    if (error.response.data.message && error.response.data.message=='Unauthorized') {
      location.reload(true);
    }
    return Promise.reject(error);
});*/

var procesando = 0; //Para que no haga 2 llamadas a verificarSesion al mismo tiempo
// Inicializar el proveedor de credenciales de Amazon Cognito



const vm = new Vue({
  render: h => h(App),
  router,
  store,
  vuetify,
  data: () => ({ fab: false,
    urlLogout: Vue.prototype.$hostname+"usuarios/logout/",
    urlVerificaSesion: Vue.prototype.$hostname+"usuarios/verifica_sesion/",
    urlGuardarUrlsVisitadas: Vue.prototype.$hostname+"usuarios/save_urls/",
    urls_usuario:[],
  }),
  watch:{
    $route: function (to, from){
       
        if(to.path != "/" && to.path != "/e-drive"   ){
            var record = {"rfc": Vue.prototype.$local_storage.get('rfc'),
              "usuario_nombre": Vue.prototype.$local_storage.get('nombre_usuario'),
              "usuario_id": Vue.prototype.$local_storage.get('id_usuario'),
              "usuario_email": Vue.prototype.$local_storage.get('email'),
              "tipo_usuario": Vue.prototype.$local_storage.get('tipo_usuario'),
              "url": to.path};
            this.urls_usuario.push(record);
        }
    }
  },
  components: { App },
  template: "<App/>",
  methods:{
    verificaSesion: function(url){
      var self = Vue.prototype.$local_storage;
        if(url == 'inactividad')
            setTimeout(vm.reiniciaInactividad, 5*60000);
        if(self.get("id_usuario") > 0 && (this.urlVerificaSesion != url && this.urlLogout != url)
              && (procesando == 0 || url == 'inactividad') ){
          var opcion = 1; //1-Actualiza tiempo de usuario, 0-No actualiza ya que es por inactividad
          if(url == 'inactividad')
                opcion = 0;
          else
            procesando = 1;

          this.guardarURLS();

            //Verificar Sesión
          var datos = { usuario: Vue.prototype.$local_storage.get('id_usuario'),
                        sistema: Vue.prototype.$sistema,
                        opcion: opcion};
            axios.put(this.urlVerificaSesion,datos)
              .then((res) => {

                  if (res.data == false){//Cerrar sesión si sobrepasó el tiempo de inactividad en la api
                      var data = {
                        usuario: self.get("id_usuario"),
                        sistema: Vue.prototype.$sistema,
                      };
                      axios
                        .post(this.urlLogout, data)
                        .then(function(response) {
                          self.set("token", "");
                          self.set("id_usuario", 0);
                          self.set("tipo_usuario", "guest");
                        })
                        .catch(function(error) {
                          self.set("token", "");
                          self.set("id_usuario", 0);
                          self.set("tipo_usuario", "guest");
                        })
                        .then(function(){
                            vm.cerrarSesion(1);
                        });
                  }

              })
              .catch((err) => {
                  console.log(err);
              })
              .then(function(){
                //Para que no vuelva a verificar sesión,hasta pasados 5 minutos
                if(url != 'inactividad')
                  setTimeout(vm.reiniciaProcesando, 5*60000);
              });
        }else if (self.get("id_usuario") == 0 && vm.verificaUrlPermitida()== undefined){
          vm.cerrarSesion(2);
        } else if(self.get("id_usuario") > 0 && this.urlLogout == url){
            this.guardarURLS();
        }
    },
    reiniciaInactividad:function(){
      vm.verificaSesion("inactividad");
    },
    reiniciaProcesando:function(){
      procesando = 0;
    },
    verificaUrlPermitida:function(){ //Son las url permitidas para acceso a usuarios invitados
      var x = window.location.pathname;
    
      var permitidas =  ["/","/usuarios/registro","/politica_privacidad"];
      var permitidasConParametros =  ["/reset/","/view_pedimento/", "/e-drive/", "/af_nacional/", "/sso"];
      var search = permitidas.find(element => element.toLowerCase() == x.toLowerCase());
      if (search == undefined){
          search = permitidasConParametros.find(element => x.toLowerCase().indexOf(element.toLowerCase()) != -1);
      }

      return search;
    },
    guardarURLS: function(){
        //Guardar URLS visitadas del usuario
        if(this.urls_usuario.length > 0){
          axios.post(this.urlGuardarUrlsVisitadas , this.urls_usuario)
            .then((res) => {
              this.urls_usuario = [];
            })
            .catch((err) => {
                console.log("Error al guardar URLS: ",err);
                this.urls_usuario = [];
            });
        }
    },
    cerrarSesion:function(opcion=1){
        this.guardarURLS();
        //window.localStorage.clear();
        Vue.prototype.$user.set({ role: "guest" });
        Vue.prototype.$user.set({ id_cliente: "0" });
        procesando = 0;
        if (opcion == 1){//Cerrar con mensaje
          router.push("/", () => {
              Vue.swal({
                type: 'warning',
                title: '¡Su sesión ha expirado!',
                text: 'Ingrese nuevamente al sistema.',
                footer: ''
            });
          });
        } else {//Solo enviamos a login
          router.push("/");
        }
    },
  }
}).$mount("#app");

getUser.then(user => {
  Vue.prototype.$user.set(user);
  vm
});
